document.addEventListener("DOMContentLoaded", function() {
  // 1. Define the input fields and the WhatsApp link element.
  var nameInput = document.getElementById('ContactForm-name');
  var emailInput = document.getElementById('ContactForm-email');
  var phoneInput = document.getElementById('ContactForm-phone');
  var messageInput = document.getElementById('ContactForm-body');
  var whatsappLink = document.getElementById('whatsappLink');

  // 2. Function to update the WhatsApp link.
  function updateWhatsAppLink() {
    var baseWhatsAppURL = "https://wa.me/+972549183817?text=";
    // 3. Construct the message from input values.
    var message = "Name: " + encodeURIComponent(nameInput.value) + 
                  "%0AEmail: " + encodeURIComponent(emailInput.value) + 
                  "%0APhone: " + encodeURIComponent(phoneInput.value) + 
                  "%0AMessage: " + encodeURIComponent(messageInput.value);
    // 4. Set the new href for the WhatsApp link.
    whatsappLink.href = baseWhatsAppURL + message;
  }

  // 5. Add event listeners to update the link whenever the user types in the input fields.
  nameInput.addEventListener('input', updateWhatsAppLink);
  emailInput.addEventListener('input', updateWhatsAppLink);
  phoneInput.addEventListener('input', updateWhatsAppLink);
  messageInput.addEventListener('input', updateWhatsAppLink);
});
